



























































import { Component, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import DialogDetail1 from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box2/dialogDetail1.vue';
import ViewHazardList from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box2/viewHazardList.vue';

@Component({
  components: { DialogDetail1, ViewHazardList },
})
export default class DialogList1 extends Vue {
  private dialogVisible = false;
  private title = '';

  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total: any = 0;
  private tableData: any = [];

  private filterForm: any = {
    deptId: '',
    status: null,
  };

  getSunStr(str: any) {
    if (str) {
      const a: any = str.indexOf('-');
      if (a !== -1) {
        return str.substr(a + 1);
      } else {
        return str;
      }
    } else {
      return '';
    }
  }

  public async showDialog(data: any) {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.title = data.type === 'check' ? '应排查' : '未排查';
    this.filterForm.status = data.type === 'check' ? null : 0;
    this.filterForm.deptId = data.deptId;
    this.getData();
    this.dialogVisible = true;
  }
  private getData() {
    zyScreenServer
      .getPatrolTaskListData({
        pageNo: this.queryDataForm.pageNo,
        pageSize: this.queryDataForm.pageSize,
        paging: true,
        deptId: this.filterForm.deptId,
        status: this.filterForm.status,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.warning(res.msg);
        }
      });
  }
  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getData();
  }
  private filterItemClick(data: any) {
    if (data.value === '0') {
      // this.tableData = [];
      return;
    }
    this.filterForm.deptId = data.other;
    this.getData();
  }
  showDetail(item: any) {
    const refName = 'DialogDetail1Ref';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(item);
  }
  viewHazardList(data: any) {
    const refName = 'ViewHazardListRef';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(data.id);
  }
  handleClose(done: any) {
    done();
  }
}
